import { render, staticRenderFns } from "./thirdPanelInfoManage.vue?vue&type=template&id=1fc70864&"
import script from "./thirdPanelInfoManage.vue?vue&type=script&lang=js&"
export * from "./thirdPanelInfoManage.vue?vue&type=script&lang=js&"
import style0 from "./thirdPanelInfoManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports